import PropTypes from 'prop-types';

import InstitutionCard from './InstitutionCard';

import './CityInstitutionsList.scss';

const CityInstitutionsList = props => {
  const { institutions, city } = props;

  return (
    <div>
      <h1 className="institutions-cards__title">{city}</h1>
      <div className="institutions-cards__wrapper">
        {institutions.map(institution => (
          <div className="institutions-cards__item" key={institution.ID}>
            <InstitutionCard institution={institution} />
          </div>
        ))}
      </div>
    </div>
  );
};

CityInstitutionsList.defaultProps = {
  institutions: [],
  city: ''
};

CityInstitutionsList.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  institutions: PropTypes.array,
  city: PropTypes.string
};

export default CityInstitutionsList;
